 
import TableContainer from "../../../../components/TableContainer/TableContainer";
import styles from "./CostCenters.module.css";

import { Delete, Block, CheckCircle, Edit } from "@mui/icons-material";

export interface ICostCenter {
  uid_centro_custo: string;
  uid_estabelecimento: string;
  nome: string;
  ativo: boolean;
  syncadmom: string;
  syncanmom?: string | null;
  tem_vinculos: boolean;
}

interface CostCenterListProps {
  rows: ICostCenter[];
  handleEdit: (item: ICostCenter) => void;
  handleToggleStatus?: (item: ICostCenter) => void;
  handleDelete?: (uid: string) => void;
}

const CostCenterList = ({ rows, handleEdit, handleToggleStatus, handleDelete }: CostCenterListProps) => {
  return (
    <div className={styles.containerTable}>
      <TableContainer
        columns={[
          { key: "nomeEx", titulo: "Nome", classStyle: styles.columnName },
          { key: "statusEx", titulo: "Status", classStyle: styles.columnStatus },
          { key: "actionEx", titulo: "Ação", classStyle: styles.columnAction },
        ]}
        content={
          rows?.map((item) => ({
            rowClass: styles.tableItem,
            values: {
              nomeEx: <strong>{item.nome}</strong>,
              statusEx: (
                <span className={`${styles.statusBadge} ${item.ativo ? styles['status-active'] : styles['status-inactive']}`}>
                  {item.ativo ? "Ativo" : "Inativo"}
                </span>
              ),
            },
            buttons: [
              {
                variant: "contain",
                typeStyle: "small",
                title: "Editar centro de custo",
                onClick: () => handleEdit(item),
                icon: <Edit />,
              },
              {
                variant: "contain",
                typeStyle: "small",
                title: item.ativo ? "Inativar" : "Ativar",
                onClick: () => handleToggleStatus ? handleToggleStatus(item) : handleEdit(item),
                icon: item.ativo ? <Block /> : <CheckCircle />,
              },
              {
                variant: "contain",
                typeStyle: ["small", "cancel"], // Regra 3: Botão de exclusão
                title: item.tem_vinculos ? "Não é possível excluir: Item possui vínculos financeiros" : "Excluir",
                disabled: item.tem_vinculos,
                onClick: () => handleDelete && handleDelete(item.uid_centro_custo),
                icon: <Delete />,
              },
            ],
          })) ?? []
        }
      />
    </div>
  );
};

export default CostCenterList;